// Wire-format types for the R-value (위험지수 / Risk Index) threshold card. PRD 09 §3.4/§4.4.
// This feature manages the threshold configuration ONLY — the R-value calculation itself is
// out of scope (see clarification ADM.031). Persisted shape per PRD 09 §4.4 canonical:
//   riskRange.{low,mid,high}.{min,max}  — all float, one decimal place.

export interface RiskInterval {
  min: number;
  max: number;
}

// Full response from GET /admin/risk-ranges and body of PUT /admin/risk-ranges.
export interface RiskRange {
  low: RiskInterval;
  mid: RiskInterval;
  high: RiskInterval;
}

export interface RiskRangeApi {
  getRange(): Promise<RiskRange>;
  updateRange(range: RiskRange): Promise<RiskRange>;
}

export type RiskRangeApiErrorCode =
  // Continuity / interval-ordering conflict rejected server-side (carries an actionable message).
  // SHCT-681 — this is the code the server actually emits (ErrorCode.RISK_BAND_NOT_CONTINUOUS); the
  // FE previously listed a RISK_RANGE_CONTINUITY that no server ever sent, so a real rejection fell
  // through to the generic save-failure copy.
  | 'RISK_BAND_NOT_CONTINUOUS'
  | 'NOT_FOUND'
  | 'INSUFFICIENT_PERMISSION'
  // Request never reached the server (offline / DNS / CORS / timeout) — Error Standard §3.
  | 'NETWORK'
  | 'UNKNOWN';

export class RiskRangeApiError extends Error {
  readonly code: RiskRangeApiErrorCode;
  readonly fields?: Record<string, string>;

  constructor(
    code: RiskRangeApiErrorCode,
    message: string,
    fields?: Record<string, string>,
  ) {
    super(message);
    this.name = 'RiskRangeApiError';
    this.code = code;
    this.fields = fields;
    Object.setPrototypeOf(this, RiskRangeApiError.prototype);
  }
}
